import React, { useState } from "react";
import { getArbokOriginFullUrl } from "../../../../../utils/media.utils";
import FsLightbox from "fslightbox-react";
const Image = (props) => {
    const { message } = props;
    const [toggler1, setToggler] = useState(false);
    const onClickHandler = () => {
        setToggler(!toggler1);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("img", { className: `cursor`, onClick: onClickHandler, src: getArbokOriginFullUrl(message.uri), alt: 'image', style: { width: "100%", height: "auto" } }),
        React.createElement(FsLightbox, { toggler: toggler1, sources: [getArbokOriginFullUrl(message.uri)], type: "image" })));
};
export default Image;
